"use client"

import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { ArrowUp } from "lucide-react"
import { Button } from "@/components/ui/button"

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down 300px
      if (window.pageYOffset > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener("scroll", toggleVisibility)

    return () => {
      window.removeEventListener("scroll", toggleVisibility)
    }
  }, [])

  // Hide scroll to top on auth and dashboard routes
  const shouldHide = location.pathname.startsWith("/auth") || 
                     location.pathname.startsWith("/dashboard") ||
                     location.pathname.startsWith("/admin");

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  if (shouldHide || !isVisible) {
    return null
  }

  return (
    <Button
      onClick={scrollToTop}
      className="fixed right-6 z-40 w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-r from-primary to-secondary hover:from-primary/90 hover:to-secondary/90 text-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 p-0 flex items-center justify-center"
      aria-label="Scroll to top"
      style={{ 
        bottom: '7.5rem', // Position safely above chatbot button and widget (chatbot button at 1.5rem/24px + 56px height = 80px, add gap = ~120px = 7.5rem)
        right: '1.5rem',
      }}
    >
      <ArrowUp className="w-5 h-5 sm:w-6 sm:h-6" />
    </Button>
  )
}
